var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrimage"},[(_vm.src)?_c('van-image',{attrs:{"src":_vm.src}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }